import { OuiTextComponent } from '@aiz-gl/omni-ui';
import { Component } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [OuiTextComponent],
  templateUrl: './logo.component.html',
})
export class LogoComponent {}
